import actionTypes from 'src/modules/redux/actionTypes'

export const setFavouriteAds = payload => ({
  type: actionTypes.SET_PROFILE_FAVOURITE_ADS,
  payload
})
